import React from 'react';

import ObjectID from 'bson-objectid';

import { washHub } from 'store/slices';
import { useCreateSite } from 'hooks/sites/useCreateSites';
import { useNavigate } from 'react-router-dom';

import { CreateSiteProps } from './CreateSite.props';

import CreateSiteView from './CreateSite.view';
import { days } from 'constants/weekdays';

const CreateSiteContainer = (props: CreateSiteProps) => {
  const newObjectId = new ObjectID().toHexString();
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const navigate = useNavigate();

  const { onCreateSite, isCreateLoading } = useCreateSite(washHubId, () => {
    navigate(-1);
  });

  const completeEmptyPayloadFields = (payload: any) => {
    const capacity = Number(payload?.capacity || '0');

    const createPortalName =
      payload?.portal === true ? payload?.portalName : ``;

    const portalName = createPortalName;

    /**
     * Because the daily state should have a deliveryDayOfTheWeek sate as every day.
     */
    const deliveryDayOfTheWeek =
      payload?.deliveryFrequency === 'Daily'
        ? (payload.deliveryDayOfTheWeek = days)
        : payload.deliveryDayOfTheWeek;

    const zip = payload?.address?.zip || null;

    payload = {
      ...payload,
      deliveryDayOfTheWeek,
      zip,
      capacity,
      washHub: payload?.washHub || washHubId,
      portal: payload?.portal,
      portalName: portalName,
      id: newObjectId,
      logo: payload?.logo || '',
      banner: payload?.banner || '',
      invoice: payload?.invoice,
      qrLandingUrl: payload?.qrLandingUrl || '',
    };

    return payload;
  };

  const onSubmit = (payload: any) => {
    delete payload._isUploading;

    const sanitizedPayload = completeEmptyPayloadFields(payload);

    onCreateSite(sanitizedPayload);
  };

  return (
    <CreateSiteView
      siteId={newObjectId}
      onSubmit={onSubmit}
      isLoading={isCreateLoading}
    />
  );
};

export default CreateSiteContainer;
